// Two-player keyboard mapping. Matches the 2011 control scheme exactly so
// it's familiar to anyone who played the original — P1 on arrow cluster +
// Insert/Delete/Home, P2 on WASD + Q/E/F.

import Phaser from "phaser";

export interface PlayerKeys {
  moveLeft: Phaser.Input.Keyboard.Key;
  moveRight: Phaser.Input.Keyboard.Key;
  moveUp: Phaser.Input.Keyboard.Key;
  moveDown: Phaser.Input.Keyboard.Key;
  punch: Phaser.Input.Keyboard.Key;
  fire: Phaser.Input.Keyboard.Key;
  heal: Phaser.Input.Keyboard.Key;
}

export interface InputBindings {
  player1: PlayerKeys;
  player2: PlayerKeys;
}

const KC = Phaser.Input.Keyboard.KeyCodes;

export function setupInput(scene: Phaser.Scene): InputBindings {
  const kb = scene.input.keyboard;
  if (!kb) throw new Error("Keyboard plugin is not available on this scene");

  return {
    player1: {
      moveLeft: kb.addKey(KC.LEFT),
      moveRight: kb.addKey(KC.RIGHT),
      moveUp: kb.addKey(KC.UP),
      moveDown: kb.addKey(KC.DOWN),
      punch: kb.addKey(KC.DELETE),
      fire: kb.addKey(KC.INSERT),
      heal: kb.addKey(KC.HOME),
    },
    player2: {
      moveLeft: kb.addKey(KC.A),
      moveRight: kb.addKey(KC.D),
      moveUp: kb.addKey(KC.W),
      moveDown: kb.addKey(KC.S),
      punch: kb.addKey(KC.Q),
      fire: kb.addKey(KC.E),
      heal: kb.addKey(KC.F),
    },
  };
}
